import React, { useState, useEffect } from "react";
import { useFormContext, Controller } from "react-hook-form";
import Input from "Components/UI/Input";
import dayjs from "dayjs";
import ImageUploader from "Components/UI/ImageUploder";
import { useCountriesQuery } from "AppQuries/master/Country/get-all-countries";
import { useAcademicsQuery } from "AppQuries/master/Academic/get-all-academics";
import { Info } from "react-feather";
import ImageUploaderOCR from "Components/UI/Image/ImageUploaderOCR";
import ImageCropper from "Components/UI/Image/ImageCropper";
const marriagestatus = [
  { id: "1", label: "Single", value: "Single" },
  { id: "2", label: "Married", value: "Married" },
  { id: "3", label: "Widowed", value: "Widowed" },
];

const boolOptions = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];

const eatingHabitOptions = [
  { label: "Veg", value: "Veg" },
  { label: "Non-Veg", value: "Non-Veg" },
];

const PersonalInformation = () => {
  const {
    control,
    formState: { errors },
    watch,
    setValue,
    trigger,
    clearErrors,
  } = useFormContext();
  const companyCode = watch("companyCode");
  const { data: countries } = useCountriesQuery(
    {
      companyCode: watch("companyCode"),
    },
    {
      enabled: !!watch("companyCode"),
    }
  );
  const { data: academics } = useAcademicsQuery(
    {
      companyCode: watch("companyCode"),
    },
    {
      enabled: !!watch("companyCode"),
    }
  );

  const countryOptions = Array.isArray(countries?.data)
    ? countries?.data
        .filter((country) => country.isActive === true)
        .map((country) => ({
          id: country.countryCode,
          label: country.country,
          value: country.country,
        }))
    : [];

  const academicOptions = Array.isArray(academics?.data)
    ? academics?.data
        .filter((o) => o.isActive === true)
        .map((o) => ({
          id: o.shortCode,
          label: o.description,
          value: o.description,
        }))
    : [];

  const setBase64Value = (value) => {
    setValue("employeePhoto", value);
  };

  return (
    <>
      <div className="addproduct-icon list icon">
        <h5>
          <Info className="add-info" />
          <span>Employee Information</span>
        </h5>
      </div>
      <div className="form-row row">
        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name="dob"
            type="date"
            placeholder=""
            className={`form-control ${errors.dob ? "is-invalid" : ""}`}
            label="Date Of Birth"
            labelClassName="form-label"
            required={true}
            requiredMessage="DOB is required"
            onChange={(selectedOption) => {
              // setValue("gender", selectedOption ? selectedOption.value : null);
              // trigger("gender");
            }}
            dateFormat="DD/MM/YYYY"
            defaultValue={dayjs(watch("dob"), "DD/MM/YYYY") || null}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name="maritalStatus"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.maritalStatus ? "is-invalid" : ""
            }`}
            label="Marital Status"
            labelClassName="form-label"
            optionData={marriagestatus}
            required={false}
            requiredMessage="Marital Status is required"
            onChange={(selectedOption) => {
              setValue("maritalStatus", selectedOption);
              trigger("maritalStatus");
            }}
            defaultValue={watch("maritalStatus")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name="academicQualification"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.academicQualification ? " is-invalid" : ""
            }`}
            label="Academic Qualification"
            labelClassName="form-label"
            optionData={academicOptions}
            required={false}
            requiredMessage="Academic Qualification is required"
            onChange={(selectedOption) => {
              setValue("academicQualification", selectedOption);
              trigger("academicQualification");
            }}
            defaultValue={watch("academicQualification")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name="address1"
            type="text"
            placeholder="Address 1"
            className={`form-control ${errors.address1 ? "is-invalid" : ""}`}
            label="Address 1"
            labelClassName="form-label"
            required={true}
            requiredMessage="Address 1 is required"
          />
        </div>
        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name="address2"
            type="text"
            placeholder="Address 2"
            className={`form-control ${errors.address2 ? "is-invalid" : ""}`}
            label="Address 2"
            labelClassName="form-label"
            required={false}
            requiredMessage="Address 2 is required"
          />
        </div>
        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name="address3"
            type="text"
            placeholder="Address 3"
            className={`form-control ${errors.address3 ? "is-invalid" : ""}`}
            label="Address 3"
            labelClassName="form-label"
            required={false}
            requiredMessage="Address 3 is required"
          />
        </div>
        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name="country"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.country ? "form-control is-invalid" : ""
            }`}
            label="Country"
            labelClassName="form-label"
            optionData={countryOptions}
            required={true}
            requiredMessage="Country is required"
            onChange={(selectedOption) => {
              setValue("country", selectedOption);
              trigger("country");

              // if (selectedOption.value === "Singapore") {
              //   setValue("residentialType", "S");
              //   trigger("residentialType");
              // }
            }}
            defaultValue={watch("country")}
          />
        </div>
        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name="postalCode"
            type="text"
            placeholder="Postal Code"
            className={`form-control ${errors.postalCode ? "is-invalid" : ""}`}
            label="Postal Code"
            labelClassName="form-label"
            required={true}
            requiredMessage="Postal Code is required"
          />
        </div>

        {/* <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name="placeOfBirth"
            type="text"
            placeholder="Place Of Birth"
            className={`form-control ${
              errors.placeOfBirth ? "is-invalid" : ""
            }`}
            label="Place Of Birth"
            labelClassName="form-label"
            required={false}
            requiredMessage=""
          />
        </div> */}

        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name="bloodGroup"
            type="text"
            placeholder="Blood Group"
            className={`form-control ${errors.bloodGroup ? "is-invalid" : ""}`}
            label="Blood Group"
            labelClassName="form-label"
            required={false}
            requiredMessage="Blood Group is required"
          />
        </div>

        {/* <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name="religion"
            type="text"
            placeholder="Religion"
            className={`form-control ${errors.religion ? "is-invalid" : ""}`}
            label="Religion"
            labelClassName="form-label"
            required={true}
            requiredMessage="Religion is required"
          />
        </div> */}

        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name="hpno"
            type="text"
            placeholder="Mobile No"
            className={`form-control ${errors.hpno ? "is-invalid" : ""}`}
            label="Mobile No"
            labelClassName="form-label"
            required={true}
            requiredMessage="Mobile No is required"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name="localContactNumber"
            type="tel"
            placeholder="Local Contact Number"
            className={`form-control ${
              errors.localContactNumber ? "is-invalid" : ""
            }`}
            label="Local Contact Number"
            labelClassName="form-label"
            required={false}
            requiredMessage=""
            pattern="^\d{8}$"
            title="Enter exactly 8 digits of numbers"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name="overseasContactNumber"
            type="tel"
            placeholder="Overseas Contact Number"
            className={`form-control ${
              errors.overseasContactNumber ? "is-invalid" : ""
            }`}
            label="Overseas Contact Number"
            labelClassName="form-label"
            required={false}
            requiredMessage="Overseas Contact Number is required"
            pattern="^\d{8}$"
            title="Enter exactly 8 digits of numbers"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name="email"
            type="email"
            placeholder="Email"
            className={`form-control ${errors.email ? "is-invalid" : ""}`}
            label="Email"
            labelClassName="form-label"
            required={false}
            requiredMessage="Email is required"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <label className="form-label" style={{ position: "absolute" }}>
            Employee Photo
          </label>
          <ImageCropper
            base64Value={watch("employeePhoto")}
            setBase64Value={(value) => setValue("employeePhoto", value)}
          />
          <div className="invalid-feedback">
            {errors.employeePhotoStr?.message}
          </div>
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <label className="form-label" style={{ position: "absolute" }}>
            Employee Sign
          </label>
          <ImageCropper
            base64Value={watch("employeeSignature")}
            setBase64Value={(value) => setValue("employeeSignature", value)}
          />
          <div className="invalid-feedback">
            {errors.employeeSignature?.message}
          </div>
        </div>
      </div>

      <div className="addproduct-icon list icon">
        <h5>
          <Info className="add-info" />
          <span>Other Information</span>
        </h5>
      </div>
      <div className="form-row row">
        <div className="col-md-6 col-lg-6 col-sm-6 mb-3">
          <Input
            name="eatingHabit"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.eatingHabit ? " is-invalid" : ""
            }`}
            label="Eating Habit"
            labelClassName="form-label"
            optionData={eatingHabitOptions}
            required={false}
            requiredMessage=""
            onChange={(selectedOption) => {
              setValue("eatingHabit", selectedOption);
              trigger("eatingHabit");
            }}
            defaultValue={watch("eatingHabit")}
          />
        </div>

        <div className="col-md-6 col-lg-6 col-sm-6 mb-3">
          <Input
            name="havingKids"
            type="commonSelect"
            placeholder=""
            className={`form-control ${errors.havingKids ? " is-invalid" : ""}`}
            label="Have Kids"
            labelClassName="form-label"
            optionData={boolOptions}
            required={false}
            requiredMessage=""
            onChange={(selectedOption) => {
              setValue("havingKids", selectedOption);
              trigger("havingKids");
            }}
            defaultValue={watch("havingKids")}
          />
        </div>

        <div className="col-md-6 col-lg-6 col-sm-6 mb-3">
          <Input
            name="havingDependants"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.havingDependants ? " is-invalid" : ""
            }`}
            label="Have Dependants"
            labelClassName="form-label"
            optionData={boolOptions}
            required={false}
            requiredMessage=""
            onChange={(selectedOption) => {
              setValue("havingDependants", selectedOption);
              trigger("havingDependants");
            }}
            defaultValue={watch("havingDependants")}
          />
        </div>

        <div className="col-md-6 col-lg-6 col-sm-6 mb-3">
          <Input
            name="accommodationByCompany"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.accommodationByCompany ? " is-invalid" : ""
            }`}
            label="Accommodation By Company"
            labelClassName="form-label"
            optionData={boolOptions}
            required={false}
            requiredMessage=""
            onChange={(selectedOption) => {
              setValue("accommodationByCompany", selectedOption);
              trigger("accommodationByCompany");
            }}
            defaultValue={watch("accommodationByCompany")}
          />
        </div>
      </div>
    </>
  );
};

export default PersonalInformation;
